<label for="receiptimgupload">
  <img
    id="receiptimgFilePreview"
    class="s-user-profile-persona"
    [src]="imageSRC ? imageSRC : '../../../assets/images/icon-default-logo-preview.svg'"
    style="cursor: pointer;"
  />
</label>
<input
  type="file"
  id="receiptimgupload"
  [accept]="allowedTypes"
  class="upload"
  (change)="onUploadImage($event)"
  hidden
/>
